module.exports = __webpack_public_path__ + "img/simple-twist-logo.d1287c47.jpg";